var isTouchDevice = function isTouchDevice() {
  if (typeof window === 'undefined') {
    if (process.env.NODE_ENV === 'development') {}
    return false;
  }
  var regx = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|DEV-Native-ios/i;
  return regx.test(navigator.userAgent);
};
export default isTouchDevice;